import { IWizardStep } from "../../../../../wizard/types";
import Content from "./Content";

export const createConfigStep5: IWizardStep = {
  width: "552px",
  titleConfig: {
    titleText: "Preview",
  },
  content: Content,
  stepName: "step5",
};
